export enum LinksNotredame {
	EXAMS_SP = 'https://www.notrelabs.com.br/resultados-acesso',
	EXAMS_RJ = 'https://resultadoexame.hapvida.com.br/resultado-exame/autenticacao.xhtml',
	NEWS = 'https://www.notredame.com.br/noticias/beneficiarios-com-planos-cancelados',
	PORTAL = 'https://www.notredame.com.br/',
	INCOME_TAX_AND_COPART = 'https://www.notredame.com.br/beneficiario',
	LGPD = 'https://www.notredame.com.br/portal-da-privacidade',
}
